module.exports = __webpack_public_path__ + "static/media/opacity-icon.2379f490.svg";